var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteDownloadPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.838 8.502v17.991a1.853 1.853 0 0 1-1.853 1.853H8.867a1.862 1.862 0 0 1-1.853-1.853V4.467c0-1.03.836-1.853 1.853-1.853h8.084l5.887 5.888z",
    fill: "#C9A87A",
    fillOpacity: 0.16
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.362 28.346H8.867a1.862 1.862 0 0 1-1.853-1.853V4.467c0-1.03.836-1.853 1.853-1.853h2.495A1.843 1.843 0 0 0 9.51 4.467v22.026c0 1.016.822 1.853 1.853 1.853z",
    fill: "#fff",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.445 2.614v5.888h5.873l-5.873-5.888z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.174 14.24v8.532m0 0-2.496-2.495m2.496 2.495 2.48-2.495M25.32 8.502 19.43 2.614H8.867a1.853 1.853 0 0 0-1.853 1.853v22.026c0 1.016.822 1.853 1.853 1.853H23.48a1.853 1.853 0 0 0 1.853-1.853V8.502h-.015zm0 0h-5.873V2.614l5.873 5.888z",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDownloadPdf);
export default __webpack_public_path__ + "static/media/whiteDownloadPDF.6ace2b07a1bce8117632c635235c0f9f.svg";
export { ForwardRef as ReactComponent };